import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import LicenseCalculatorWidget from "../api/LicenseCalculatorWidget";
import { canViewLicenseCalculator } from "../utils/canViewLicenseCalculator";
import { LicenseCalculatorDrawer } from "./licensing/LicenseCalculatorDrawer";
import RolesState from "../api/RolesState";

export const HeaderLicenseCalculator = observer(({ showNavIcons }) => {
  const [open, setOpen] = useState(false);

  if (!canViewLicenseCalculator() || !LicenseCalculatorWidget.enabled || !RolesState.get_integration_1c_prices) {
    return null;
  }

  return (
    <>
      <button
        type="button"
        className="header-notes-trigger header-license-calculator-trigger"
        onClick={() => setOpen(true)}
        aria-pressed={open}
        aria-label="Калькулятор лицензий"
        title="Калькулятор лицензий"
      >
        {showNavIcons ? (
          <span className="header-license-calculator-trigger-short" aria-hidden="true">
            К
          </span>
        ) : (
          <span className="header-calc-font">Калькулятор лицензий</span>
        )}
      </button>
      <LicenseCalculatorDrawer open={open} onClose={() => setOpen(false)} />
    </>
  );
});
